import { FormStylingOptions } from '../models';

export const DEFAULT_FORM_STYLING: FormStylingOptions = {
    background: 'muted',
    actionButtonPosition: 'top',
};
